import {
  HANDSHAKE_ACK_KIND,
  type HandshakeAck,
  type MessageUnion,
  type ProtocolMessage,
} from "@moonpay/platform-protocol/protocol";

// ---------------------------------------------------------------------------
// Parse a V2 protocol message from raw postMessage data
// ---------------------------------------------------------------------------

export function parseFrameMessage<M extends Record<string, unknown> = Record<string, unknown>>(
  data: string,
  expectedChannelId: string,
): MessageUnion<M> | ProtocolMessage | null {
  try {
    const msg = JSON.parse(data);
    if (msg.version !== 2) {
      return null;
    }
    if (msg.meta?.channelId !== expectedChannelId) {
      return null;
    }
    if (typeof msg.kind !== "string") {
      return null;
    }
    return msg;
  } catch {
    return null;
  }
}

// ---------------------------------------------------------------------------
// Build an ack message to complete the V2 handshake
// ---------------------------------------------------------------------------

export function buildAckMessage(channelId: string): HandshakeAck {
  return {
    version: 2,
    meta: { channelId },
    kind: HANDSHAKE_ACK_KIND,
  };
}

// ---------------------------------------------------------------------------
// Generate a unique channel ID (UUID v4)
// ---------------------------------------------------------------------------

export function generateChannelId(): string {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x40;
  bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80;
  const hex = Array.from(bytes)
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
